import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabaseClient.ts';


function ShopAreaBird() {
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedSubcategory, setSelectedSubcategory] = useState("");
  const navigate = useNavigate();

  // Fetch categories and products for 'cat'
  useEffect(() => {
    const fetchCategories = async () => {
      const { data, error } = await supabase
        .from("categories")
        .select("*")
        .eq("pet_type", "oiseaux")
        .order("order", { ascending: true })


      if (error) {
        console.error("Error fetching categories:", error);
      } else {
        setCategories(data);
        if (data.length > 0) {
          setSelectedCategory(data[0].name); // Default category
        }
      }
    };

    const fetchProducts = async () => {
      const { data, error } = await supabase
        .from("products")
        .select("id, name, image, price_range, description, category, subcategory");

      if (error) {
        console.error("Error fetching products:", error);
      } else {
        setProducts(data);
      }
    };

    fetchCategories();
    fetchProducts();
  }, []);

  const selectedCategoryObj = categories.find((cat) => cat.name === selectedCategory);
  const subcategories = selectedCategoryObj?.subcategories || [];

  return (
    <div className="shop-area pt-50 pb-110">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="shop-wrap">
              <h4 className="title mb-4">Categories</h4>

              {/* Category Cards */}
              <div className="row mb-4">
                {categories.map(cat => {
                  const productCount = products.filter(p => p.category === cat.name).length;
                  const isSelected = selectedCategory === cat.name;

                  return (
                    <div key={cat.name} className="col-lg-3 col-md-4 col-sm-6 mb-3">
                      <button
                        onClick={() => {
                          navigate(`/category/${cat.id}/${encodeURIComponent(cat.name)}`);
                        }}

                        style={{
                          width: "100%",
                          height: "230px",
                          backgroundColor: isSelected ? "#fff" : "#fff",
                          color: isSelected ? "#333" : "#333",
                          border: isSelected ? "2px solid #000" : "1px solid #ddd",
                          borderRadius: "12px",
                          overflow: "hidden",
                          padding: 0,
                          textAlign: "center",
                          fontWeight: "bold",
                          fontSize: "15px",
                          transition: "all 0.3s ease",
                          boxShadow: isSelected ? "0 4px 10px rgba(0,0,0,0.2)" : "0 2px 6px rgba(0,0,0,0.06)",
                        }}
                      >
                        <div style={{ height: "100px", overflow: "hidden" }}>
                          <img
                            src={cat.image}
                            alt={cat.name}
                            style={{
                              width: "40%",
                              height: "90%",
                              objectFit: "cover",
                              marginLeft: window.innerWidth <= 768 ? "210px" : "0px", // shift on mobile
                            }}
                          />

                        </div>
                        <div style={{ padding: "8px" }}>
                          {cat.name}

                        </div>
                      </button>
                    </div>
                  );
                })}
              </div>

              {/* Subcategory Filter */}
              {subcategories.length > 0 && (
                <div
                  className="subcategory-filter d-flex flex-wrap gap-3 mb-4"
                  style={{ justifyContent: "flex-start" }}
                >
                  {subcategories.map((sub) => (
                    <button
                      key={sub}
                      onClick={() => setSelectedSubcategory(sub)}
                      style={{
                        borderRadius: "16px",
                        padding: "10px 20px",
                        fontSize: "15px",
                        fontWeight: "500",
                        border: selectedSubcategory === sub ? "2px solid #c71585" : "1px solid #ccc",
                        backgroundColor: selectedSubcategory === sub ? "#fce5ef" : "#f9f9f9",
                        color: selectedSubcategory === sub ? "#c71585" : "#333",
                        transition: "all 0.3s ease",
                        cursor: "pointer",
                        marginRight: "12px",     // <-- added spacing
                        marginBottom: "12px",    // <-- spacing between rows
                      }}
                    >
                      {sub}
                    </button>
                  ))}
                  <button
                    onClick={() => setSelectedSubcategory("")}
                    style={{
                      borderRadius: "16px",
                      padding: "10px 20px",
                      fontSize: "15px",
                      fontWeight: "500",
                      border: selectedSubcategory === "" ? "2px solid #c71585" : "1px solid #ccc",
                      backgroundColor: selectedSubcategory === "" ? "#fce5ef" : "#f9f9f9",
                      color: selectedSubcategory === "" ? "#c71585" : "#333",
                      transition: "all 0.3s ease",
                      cursor: "pointer",
                      marginRight: "12px",     // <-- added spacing
                      marginBottom: "12px",
                    }}

                  >
                    Tous
                  </button>
                </div>
              )}

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}


export default ShopAreaBird;
